import React from 'react';
import { connect } from 'react-redux';
import Component from './Component';
import { checkSession } from '../actions/UserActions';
import LoginScreen from './LoginScreen';
import { isDevelopment } from '../utils/utils';

class AuthWrapper extends Component {
  componentDidMount() {
    // Skip authentication check if running in development mode
    if (isDevelopment()) {
      return;
    }

    // Check session on mount if not already authenticated
    if (!this.props.isAuthenticated && !this.props.isChecking) {
      this.props.checkSession();
    }
  }

  render() {
    const { isChecking, isAuthenticated, children } = this.props;

    // Skip authentication if running in development mode
    if (isDevelopment()) {
      return <>{children}</>;
    }

    // Show loading whilst checking session
    if (isChecking) {
      return (
        <div className="auth-loading">
          <div className="loading-spinner" />
          <p>Checking authentication...</p>
        </div>
      );
    }

    // Show login screen if not authenticated
    if (!isAuthenticated) {
      return <LoginScreen />;
    }

    // Render protected content
    return <>{children}</>;
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.user.isAuthenticated,
  isChecking: state.user.isChecking
});

const mapDispatchToProps = { checkSession };

export default connect(mapStateToProps, mapDispatchToProps)(AuthWrapper);
